import type { IRoute } from '@/shared/models/route.model';
import UserGuard from '../guards/UserGuard';
import EditorLayout from '../layout/EditorLayout';
import { lazy } from 'react';

// 1. Definicja loaderów (funkcji importujących)
const loaders = {
  MainPage: () => import('../pages/main-page/MainPage'),
  CreateAdsStepsPage: () => import('../pages/create-ads-steps-page/CreateAdsStepsPage'),
  OrderDetailsPage: () => import('../pages/orders/details/OrderDetailsPage'),
  UserProfilePage: () => import('../pages/user-profile/UserProfilePage'),
  VideoLibrary: () => import('../pages/video-library/VideoLibrary'),
};

const MainPage = lazy(loaders.MainPage);
const CreateAdsStepsPage = lazy(loaders.CreateAdsStepsPage);
const OrderDetailsPage = lazy(loaders.OrderDetailsPage);
const UserProfilePage = lazy(loaders.UserProfilePage);
const VideoLibrary = lazy(loaders.VideoLibrary);

export const prefetchEditorRoutes = () => {
  Object.values(loaders).forEach((load) => load());
};

export const editorRoutes: IRoute[] = [
  {
    path: '/editor',
    component: EditorLayout,
    guard: UserGuard,
    children: [
      { path: '', component: MainPage },
      { path: 'advertise/add', component: CreateAdsStepsPage },
      { path: 'orders/:id/details', component: OrderDetailsPage },
      { path: 'users/:userId/user-profile', component: UserProfilePage },
      { path: 'videoLibrary', component: VideoLibrary },
    ],
  },
];
